module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-fade-in-linear",
      "mode": "out-in"
    }
  }, [_c('div', [_c('section', {
    staticClass: "section section-white category-view-warp",
    style: ('height: ' + (_vm.wheight - 160) + 'px;')
  }, [_c('div', {
    staticClass: "category-view"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "layout-view"
  }, [(_vm.series.length > 0) ? _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.editableSeries),
      callback: function($$v) {
        _vm.editableSeries = $$v
      },
      expression: "editableSeries"
    }
  }, _vm._l((_vm.series), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), (_vm.editableData.length > 0) ? _c('div', [_c('div', {
    staticClass: "layout-view"
  }, [_c('div', {
    staticClass: "parent-view"
  }, _vm._l((_vm.editableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "parent-item",
      class: {
        active: index === _vm.curIdx
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.name ? item.name : '楼层') + "\n                  ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "child-layout-view"
  }, [(_vm.editableData[_vm.curIdx].tags.length) ? _c('div', {
    staticClass: "tags-view"
  }, [_c('div', {
    staticClass: "tags-wrap"
  }, [_c('ul', {
    staticClass: "tags"
  }, [_c('li', {
    staticClass: "tag-item",
    class: {
      active: _vm.currentTag === ''
    },
    on: {
      "click": function($event) {
        _vm.currentTag = ''
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.editableData[_vm.curIdx].tags), function(item, idx) {
    return _c('li', {
      staticClass: "tag-item",
      class: {
        active: _vm.currentTag === item.id
      },
      on: {
        "click": function($event) {
          return _vm.handleTagClick(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.editableData[_vm.curIdx].stores.length) ? _c('div', {
    staticClass: "stores-list"
  }, _vm._l((_vm.editableData[_vm.curIdx].stores), function(item) {
    return (_vm.currentTag === '' || item.tags.findIndex(function (n) { return n.id === _vm.currentTag; }) !== -1) ? _c('div', {
      key: item.distributor_id,
      staticClass: "store-item"
    }, [_c('img', {
      staticClass: "store-img",
      attrs: {
        "src": item.logo ? item.logo : 'https://fakeimg.pl/50x50/EFEFEF/CCC/',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "store-caption"
    }, [_c('div', {
      staticClass: "store-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "store-tag"
    }, _vm._l((item.tags), function(tag) {
      return _c('span', [_vm._v(_vm._s(tag.name))])
    }), 0)])]) : _vm._e()
  }), 0) : _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-shapes"
  }), _vm._v("\n                    请绑定楼层店铺\n                  ")])])])]) : _vm._e(), _vm._v(" "), (!_vm.editableData.length) ? _c('div', {
    staticClass: "no-category-placeholder"
  }, [_c('div', {
    staticClass: "iconfont icon-cubes"
  }), _vm._v(" "), _c('div', [_vm._v("请添加楼层")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "category-setting-view"
  }, [_c('div', {
    staticClass: "category-form"
  }, [_c('div', {
    staticClass: "content-bottom-padded clearfix"
  }, [_c('div', {
    staticClass: "series"
  }, [(_vm.series.length > 0) ? _c('el-tabs', {
    attrs: {
      "type": "card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.removeTab,
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.editableSeries),
      callback: function($$v) {
        _vm.editableSeries = $$v
      },
      expression: "editableSeries"
    }
  }, _vm._l((_vm.series), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "160"
    },
    model: {
      value: (_vm.seriesVisible),
      callback: function($$v) {
        _vm.seriesVisible = $$v
      },
      expression: "seriesVisible"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "size": "small",
      "placeholder": "请输入系列名称"
    },
    model: {
      value: (_vm.seriesTitle),
      callback: function($$v) {
        _vm.seriesTitle = $$v
      },
      expression: "seriesTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "text"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addSeries
    }
  }, [_vm._v("确定")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "add-btn iconfont icon-plus-circle",
    attrs: {
      "slot": "reference",
      "type": "text"
    },
    slot: "reference"
  }, [_vm._v(" 添加区域")])], 1)], 1)]), _vm._v(" "), _c('draggable', _vm._b({
    model: {
      value: (_vm.editableData),
      callback: function($$v) {
        _vm.editableData = $$v
      },
      expression: "editableData"
    }
  }, 'draggable', _vm.dragOptions, false), _vm._l((_vm.editableData), function(item, idx) {
    return _c('div', {
      key: item._uid || idx,
      staticClass: "form-parent"
    }, [_c('div', {
      staticClass: "form-item"
    }, [_c('div', {
      staticClass: "control-bar move iconfont icon-stream"
    }), _vm._v(" "), _c('div', {
      staticClass: "control-bar remove iconfont icon-cog",
      on: {
        "click": function($event) {
          return _vm.showStore(idx)
        }
      }
    }), _vm._v(" "), _c('el-input', {
      attrs: {
        "placeholder": "楼层"
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "control-bar remove iconfont icon-trash",
      on: {
        "click": function($event) {
          return _vm.remove(idx)
        }
      }
    })], 1)])
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "parent-add-btn iconfont icon-plus",
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v(" 添加楼层")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "content-padded-s section-white content-center"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('storeList', {
    attrs: {
      "visible": _vm.storePickerVisible,
      "multiple": "",
      "data": _vm.curStores
    },
    on: {
      "onClose": _vm.handleClose,
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.storeVisible,
      "title": "编辑商铺",
      "width": "24"
    },
    on: {
      "update:visible": function($event) {
        _vm.storeVisible = $event
      }
    }
  }, [(_vm.curStores.length) ? _c('div', {
    staticClass: "stores-list"
  }, _vm._l((_vm.curStores), function(item, idx) {
    return _c('div', {
      key: item.distributor_id,
      staticClass: "store-item"
    }, [_c('img', {
      staticClass: "store-img",
      attrs: {
        "src": item.logo ? item.logo : 'https://fakeimg.pl/50x50/EFEFEF/CCC/',
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "store-caption"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash",
      on: {
        "click": function($event) {
          return _vm.handleStoreRemove(idx)
        }
      }
    })])
  }), 0) : _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-store"
  }), _vm._v("\n          请绑定楼层店铺\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "control-bar bind iconfont icon-cog",
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.bindStore()
      }
    }
  }, [_vm._v(" 选择商铺")])], 1)])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-392a4412", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392a4412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/floor_guide.vue
// module id = 2622
// module chunks = 0